export default __webpack_public_path__ + "media/images/computer-man-fded4ce7f0bdf397aa189dec38b756a1.png";